import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Select, Input } from "@components/form";

function CompanySearch({ defaultValues, onSearch, onReset }) {

  const methods = useForm({
    defaultValues,
  });
  const { handleSubmit, reset } = methods;

  const handleSearchSubmit = (formData) => {
    onSearch(formData); 
  };

  const handleReset = () => {
    if (!window.confirm('조회 조건을 초기화 하시겠습니까?')) return;  
    reset({
      searchCnd  : "",
      searchWrd  : "",
    });
    onReset && onReset();
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(handleSearchSubmit)}>
        <div className="search-wrap">
          <div className="search-row">
            <div className="search-item">
            <label style={{ marginLeft: "10px" }}>조회조건</label>
              <Select
                name="searchCnd"
                options={[
                  { key: "0", name: "회사명" },
                  { key: "1", name: "업태" },
                  { key: "2", name: "종목" },
                  { key: "3", name: "사업자등록번호" },
                  { key: "4", name: "전화번호" },
                ]}
                defaultOption="선택"
                className="input-select"
              />
              <Input
                name="searchWrd"
                placeholder="검색어를 입력하세요"
                className="input-search"
                style={{ width: "250px" }}
              />
            </div>

            <div className="search-btn-container">
              <button type="submit" className="btn-search">조회</button>
              <button type="button" className="btn-reset" onClick={handleReset}>초기화</button>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
}

export default CompanySearch;
